// extracted by mini-css-extract-plugin
export default {"wrapper":"BundleType_wrapper","small":"BundleType_small"};